// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__12gFe","inner":"Footer_inner__257E2","nextIcon":"Footer_nextIcon__5olzQ","innerLeft":"Footer_innerLeft__1c7CJ"};